// extracted by mini-css-extract-plugin
module.exports = {"instagramWrapper":"Vc","innerTile":"Wc","heading":"Xc","instaTileBtn":"Yc","disabled":"Zc","instaTileElement":"_c","instagramPic":"ad"};